/**
 * Generated initials-avatar palette (no photo uploads in v1). A user's
 * avatar tint is assigned deterministically from a stable seed (BA Number or
 * id) so the same person always renders the same color. Stored on the user
 * row (`avatarColor`) at registration; the frontend falls back to
 * `pickAvatarColor(id)` when the column is null (e.g. seeded CO/operator).
 *
 * Tints are mid-saturation hex values chosen to keep white initials legible.
 */
export const AVATAR_COLORS: readonly string[] = [
  '#15355d', // navy
  '#0e7490', // cyan-700
  '#047857', // emerald-700
  '#b45309', // amber-700
  '#b91c1c', // red-700
  '#6d28d9', // violet-700
  '#be185d', // pink-700
  '#1d4ed8', // blue-700
  '#4d7c0f', // lime-700
  '#0f766e', // teal-700
] as const;

/** Deterministically pick a palette color from an arbitrary seed string. */
export function pickAvatarColor(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  }
  const index = Math.abs(hash) % AVATAR_COLORS.length;
  return AVATAR_COLORS[index] as string;
}

/** Initials from a name (e.g. "Mohiuddin Karim" → "MK"); falls back to "?". */
export function initialsFromName(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return (parts[0] as string).slice(0, 2).toUpperCase();
  const first = parts[0] as string;
  const last = parts[parts.length - 1] as string;
  return (first[0] ?? '').concat(last[0] ?? '').toUpperCase();
}
